// The help site is built from /FarmUpHelp into public/help, so it is served by the portal itself.
const HELP_BASE_URL = '/help';
// Portuguese is the help's root; English and Spanish live under /help/en/ and /help/es/.
const HELP_LANG_PATHS = { pt: '', en: 'en/', es: 'es/' };

// URL of the FarmUp help in the given portal language, optionally with a search query
// (the help site reads ?q= and opens its search with the text already filled in).
export default function getHelpUrl(lang, query = '') {
  const langPath = HELP_LANG_PATHS[lang] ?? '';
  const q = query.trim();
  return `${HELP_BASE_URL}/${langPath}${q ? `?q=${encodeURIComponent(q)}` : ''}`;
}
